import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const ChevronUpSolid = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 20 20'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.6482 12.8567C15.4229 13.082 15.1173 13.2085 14.7988 13.2085C14.4802 13.2085 14.1746 13.082 13.9493 12.8567L9.99275 8.90017L6.0362 12.8567C5.80959 13.0756 5.50609 13.1967 5.19106 13.1939C4.87603 13.1912 4.57468 13.0648 4.35191 12.8421C4.12914 12.6193 4.00278 12.318 4.00005 12.0029C3.99731 11.6879 4.11841 11.3844 4.33728 11.1578L9.14328 6.35178C9.3686 6.12654 9.67415 6 9.99275 6C10.3113 6 10.6169 6.12654 10.8422 6.35178L15.6482 11.1578C15.8735 11.3831 16 11.6887 16 12.0073C16 12.3258 15.8735 12.6314 15.6482 12.8567Z'
      />
    </svg>
  );
};
